import React from 'react';
import { connect } from 'react-redux';
import { Form as FinalForm, FormRenderProps } from 'react-final-form';
import { Form, Button, Grid } from 'semantic-ui-react';

// Global Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';
import { requestSaveEntities } from 'services/entities/actions';

// Local Constants
import { QUERY_STRING_PARAM } from '../../constants';

interface DispatchProps {
    updateQueryString: Function;
    requestSaveEntities: Function;
    refresh: boolean;
}

export type Props = DispatchProps;

export class EntitiesSaveErrorFormComponent extends React.PureComponent<Props> {
    handleClose = (): void => {
        const { props } = this;
        props.updateQueryString({
            [QUERY_STRING_PARAM]: undefined
        });
        if (props.refresh) {
            window.location.reload();
        }
    };

    handleSubmit = (): void => {
        const { props } = this;

        this.handleClose();
        props.requestSaveEntities();
    };

    renderForm = ({
        handleSubmit
    }: FormRenderProps<{}>): React.ReactElement => {
        return (
            <Form onSubmit={handleSubmit}>
                <Grid textAlign={this.props.refresh ? 'center' : undefined}>
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                        <Button
                            type="button"
                            onClick={this.handleClose}
                            fluid
                            basic={!this.props.refresh}
                            primary
                        >
                            {this.props.refresh ? (
                                <React.Fragment>OK</React.Fragment>
                            ) : (
                                <React.Fragment>Cancel</React.Fragment>
                            )}
                        </Button>
                    </Grid.Column>
                    {!this.props.refresh && (
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                            <Button type="submit" primary fluid>
                                Retry
                            </Button>
                        </Grid.Column>
                    )}
                </Grid>
            </Form>
        );
    };

    render(): React.ReactElement {
        return (
            <FinalForm onSubmit={this.handleSubmit} render={this.renderForm} />
        );
    }
}

export default connect(null, {
    updateQueryString,
    requestSaveEntities
})(EntitiesSaveErrorFormComponent);
